// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NY","show":"NZ","dark":"N0","top":"N1","bottom":"N2","left":"N3","right":"N4"};